import React from "react";
import { bool, func, string, shape } from "prop-types";
import FileDropzone from "../../common/FileDropzone/FileDropzone";
import style from "./stylesDocs.scss";
import { isMobile } from "../../helpers";

const documentsCodes = {
  JPDL: "Driving Licence front",
  JDLB: "Driving Licence back",
  JCPC: "CPC Card front",
  JCPB: "CPC Card back",
  JDIG: "Digi Card",
};

const DrivingUpload = ({
  state,
  handleChange,
  isUpdating,
  setType,
  isFileValid,
  handleInvalidType,
}) => {
  const fileTypeHint = `Choose an image of your document.\nThis should be a JPEG or PNG file.`;
  const docCodes = { ...documentsCodes };

  return (
    <div className="mt-1 row">
      {isUpdating && (
        <h5 className="d-none d-lg-inline col-12">Add a new document</h5>
      )}
      <div className="form-group col-12 col-md-8 col-lg-6">
        <label>Document Type</label>
        <select
          className="form-control"
          id="fileTypeCode"
          onChange={(e) => {
            const selected = e.target.selectedOptions[0];
            setType(selected.text, selected.value);
          }}
          value={state.fileTypeCode}
        >
          <option value="">Select the type of document</option>
          {Object.keys(docCodes)
            .sort((a, b) => docCodes[a].localeCompare(docCodes[b]))
            .map((code) => (
              <option value={code} key={code}>
                {docCodes[code]}
              </option>
            ))}
        </select>
      </div>
      {((state.fileTypeCode !== "" && isMobile && state.documentFile) ||
        (state.fileTypeCode !== "" && !isMobile)) && (
        <div className="p-1 w-100">
          <FileDropzone
            fileTypeHint={fileTypeHint}
            acceptedFileTypes={".jpg,.jpeg,.png"}
            handleChange={handleChange}
            fileStateName="documentFile"
            fileParsedToString={state.documentFile}
            isFileValid={isFileValid}
            handleInvalidType={handleInvalidType}
            wrongFileTypeHint={
              "Your document needs to be provided as a JPEG or PNG file."
            }
            dropFileMsg={`Drop your ${docCodes[state.fileTypeCode]} file here`}
            fileCategory={"document"}
            height={isUpdating ? "315px" : "400px"}
            width="100%"
          />
        </div>
      )}
      {!(state.documentFile || !isFileValid) && (
        <div className={style.documentation_form__blank}>
          <span className={style.documentation_form__hint}>{fileTypeHint}</span>
        </div>
      )}
    </div>
  );
};

DrivingUpload.propTypes = {
  isUpdating: bool,
  state: shape({
    documentFile: string,
    fileTypeCode: string,
  }),
  handleChange: func,
  setType: func,
  isFileValid: bool,
  handleInvalidType: func,
  responsibleTeam: string,
};

export default DrivingUpload;
